<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    viewBox="0 0 24 24">
    <title :id="iconName">{{ iconName }} icon</title>
    <g :fill="iconColor">
      <path
        d="M18.5,6.5C19.3,6.5,20,5.8,20,5V3c0-0.8-0.7-1.5-1.5-1.5S17,2.2,17,3v2C17,5.8,17.7,6.5,18.5,6.5z M5.5,6.5
          C6.3,6.5,7,5.8,7,5V3c0-0.8-0.7-1.5-1.5-1.5S4,2.2,4,3v2C4,5.8,4.7,6.5,5.5,6.5z M21.5,3.5C21.2,3.5,21,3.7,21,4v1
          c0,1.4-1.1,2.5-2.5,2.5S16,6.4,16,5V4c0-0.3-0.2-0.5-0.5-0.5h-7C8.2,3.5,8,3.7,8,4v1c0,1.4-1.1,2.5-2.5,2.5S3,6.4,3,5V4
          c0-0.3-0.2-0.5-0.5-0.5C1.1,3.5,0,4.6,0,6v14c0,1.4,1.1,2.5,2.5,2.5h19c1.4,0,2.5-1.1,2.5-2.5V6C24,4.6,22.9,3.5,21.5,3.5z M23,20
          c0,0.8-0.7,1.5-1.5,1.5h-19C1.7,21.5,1,20.8,1,20V9.5h22V20z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "calendar",
    },
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>

<style scoped></style>
